import { setComponentMapOverrides } from '@jutro/uiconfig';

import FNOLLRPWizard from './FNOLLRPWizard';

setComponentMapOverrides(
    {
        FNOLLRPWizard: { component: 'FNOLLRPWizard' }
    },
    {
        FNOLLRPWizard
    }
);

export {
    FNOLLRPWizard as default
};
